import "core-js/modules/es6.function.name";
import staticQueryData from "../../public/static/d/2121081689.json";
import React from "react";
import { FaLinkedin, FaGithubSquare } from "react-icons/fa";
import styles from "./bio.module.css";
var Bio = function Bio() {
    var data = staticQueryData.data;
    var _data$site$siteMetada = data.site.siteMetadata, author = _data$site$siteMetada.author, social = _data$site$siteMetada.social;
    var iconSize = 32;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.spotlightWrapper
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.spotlightHeader
    }, author.name), /*#__PURE__*/ React.createElement("div", {
        className: styles.spotlightContent
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.iconContainer
    }, /*#__PURE__*/ React.createElement("a", {
        className: styles.iconLink,
        href: "https://linkedin.com/in/" + social.linkedin,
        target: "_blank"
    }, /*#__PURE__*/ React.createElement(FaLinkedin, {
        size: iconSize
    })), /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: "0 15px"
        }
    }), /*#__PURE__*/ React.createElement("a", {
        className: styles.iconLink,
        href: "https://github.com/" + social.github,
        target: "_blank"
    }, /*#__PURE__*/ React.createElement(FaGithubSquare, {
        size: iconSize
    }))), /*#__PURE__*/ React.createElement("p", {
        className: styles.summaryText
    }, author.summary)));
};
export default Bio;
